module.exports = __webpack_public_path__ + "img/maximize-02.6e3540b7.svg";